import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@massilia/ui';
import { OptionalLabel } from '@massilia/ui';
import { Switch } from '@massilia/ui';
import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '../hooks/use-app-form.js';
import { FieldError } from './field-error';
export default function SwitchField({ className, containerClassName, disabled, errorAsString = false, label, ...props }) {
    const field = useFieldContext();
    const errors = useStore(field.store, (state) => state.meta.errors);
    return (_jsxs("div", { className: cn('flex flex-1 flex-row justify-between', containerClassName), children: [_jsx(OptionalLabel, { "aria-invalid": errors.length > 0, label: label, optional: true }), _jsx(Switch, { "aria-invalid": errors.length > 0, checked: field.state.value ?? false, className: className, disabled: disabled, onBlur: field.handleBlur, onCheckedChange: (checked) => {
                    field.handleChange(checked);
                }, ...props }), _jsx(FieldError, { asString: errorAsString, errors: errors })] }));
}
